import { Box, Button, Icons, Text } from '@mnd-frontend/ui/publish/components';
import { breakpoints } from '@mnd-frontend/ui/publish/utils';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import routes from '../../../../routes';

const Wrapper = styled.div`
  & > * {
    max-width: ${breakpoints.phablet}px;
    margin: auto;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  height: auto;
`;

const Layout = styled.div`
  text-align: center;

  & > * + * {
    margin-top: 1rem;
  }
`;

const TwoFactorEnforced = ({ pressroomId }: { pressroomId: string }) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Box>
        <Layout>
          <Icons.PasswordUnlock $size="lg" $color="RED_700" />
          <div>
            <Text as="h2" variant="headlineMedium" marginBottom="SPACING_1">
              {t('authentication_blocking-page_title')}
            </Text>
            <Text as="p" variant="body">
              {t('authentication_blocking-page_subtitle')}
            </Text>
          </div>
          <Button href={routes.userSettingsWithPressroom2FaSetup({ pressroomId })}>
            {t('authentication_blocking-page_button')}
          </Button>
        </Layout>
      </Box>
    </Wrapper>
  );
};

export default TwoFactorEnforced;
